var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.38625,
    cy: 3.38625,
    r: 3.38625,
    transform: "matrix(1 0 0 -1 0.966797 7.75488)",
    fill: "#F0823E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "inner",
    cx: 2.32432,
    cy: 2.32432,
    r: 2.32432,
    transform: "matrix(1 0 0 -1 2.02832 6.69336)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.970358,
    cy: 0.970358,
    r: 0.970358,
    transform: "matrix(1 0 0 -1 3.38281 5.33887)",
    fill: "#F0823E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotActive);
export default __webpack_public_path__ + "static/media/dot-active.958d90204d5d3e35e94dfa778e09ef11.svg";
export { ForwardRef as ReactComponent };